import { render, staticRenderFns } from "./SellMultipleProducts.vue?vue&type=template&id=237dda36&scoped=true"
import script from "./SellMultipleProducts.vue?vue&type=script&lang=js"
export * from "./SellMultipleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237dda36",
  null
  
)

export default component.exports